// extracted by mini-css-extract-plugin
module.exports = {"menusDropZoneArea":"MenusSalesDropZone_menusDropZoneArea__3IsHB","menusDropZoneTitle":"MenusSalesDropZone_menusDropZoneTitle__20KfX"};